import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { SERVICES, HttpMethods } from '../../../services/api';
import { basicApiAsyncThunkCreator } from '../../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../../rootReducer';
import { ISendLicenseInvoiceRequest, ISendLicenseInvoiceData } from './interfaces';
import { showErrorMessage, showSuccessMessage } from '../../notifications';
import { Features, isFeatureEnabled } from '../../../featureToggles/features';

export const SEND_LICENSE_INVOICE_THUNK_PREFIX = 'account/sendLicenseInvoice';
export const sendLicenseInvoice: AsyncThunk<void, ISendLicenseInvoiceRequest, ThunkAPI> =
  createAsyncThunk(
    SEND_LICENSE_INVOICE_THUNK_PREFIX,
    async (data, thunk) => {
      try {
        const additionalData = isFeatureEnabled(Features.BillingUserFacing) ? {
          carbonCopyRecipients: data?.carbonCopyRecipients
        } : {};
        const amount = data.amount;
        delete data.amount;

        const response = await basicApiAsyncThunkCreator<void, ISendLicenseInvoiceData>({
          endpoint: `accounts/enterprise/${data.accountId}/send-invoice/licenses-add`,
          microservice: SERVICES.USERS_SERVICE,
          authenticated: true,
          method: HttpMethods.Post,
          contentType: 'application/json'
        })({
          licenseAdditionDealId: data.licenseAdditionDealId,
          invoiceNotes: data.invoiceNotes,
          ...additionalData
        }, thunk);
        const message = isFeatureEnabled(Features.DealZero) && amount === 0
          ? 'The process was successfully completed!'
          : 'Invoice has been sent!';

        thunk.dispatch(showSuccessMessage(message));
        return response;
      } catch (error) {
        thunk.dispatch(showErrorMessage(JSON.stringify(error)));
        return thunk.rejectWithValue(error);
      }
    }
  );
